import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn'
import formatDistance from 'date-fns/locale/pl/_lib/formatDistance'
import formatRelative from 'date-fns/locale/pl/_lib/formatRelative'
import localize from 'date-fns/locale/pl/_lib/localize'
import match from 'date-fns/locale/pl/_lib/match'
import formatLong from 'date-fns/locale/pl/_lib/formatLong'

const monthValues = {
  wide: [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień',
  ],
}

export const Locale = {
  formatDistance,
  formatLong,
  formatRelative,
  localize: {
    ...localize,
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: 'wide',
      defaultFormattingWidth: 'wide',
    }),
  },
  match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1,
  },
}
